<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class AdditionalAgreementCheckboxes extends Vue {
        @Prop({required: true}) roomOffers

        render() {
            return null
        }
    }

    export default AdditionalAgreementCheckboxes
</script>
